(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["studio-market-availability"] && !Shopify.designMode) return;
  try {
    (() => {
  const getConfig = () => {
    try { return JSON.parse(document.getElementById('StudioConfig')?.textContent || '{}'); }
    catch { return {}; }
  };
  const unlock = () => {
    const config = getConfig();
    document.querySelectorAll('[data-studio-product]').forEach(root => {
      root.querySelectorAll('[data-studio-variant], [data-studio-add], [data-studio-sticky-add]').forEach(control => { control.disabled = false; });
      root.querySelectorAll('[data-studio-native-variant] option').forEach(option => { option.disabled = false; });
      if (config.addLabel) {
        root.querySelectorAll('[data-studio-add-label]').forEach(label => { label.textContent = config.addLabel; });
        const sticky = root.querySelector('[data-studio-sticky-add]');
        if (sticky) sticky.textContent = config.addLabel;
      }
    });
    document.querySelectorAll('[data-studio-build]').forEach(root => {
      root.querySelectorAll('[data-studio-build-qty], [data-studio-build-card] [data-step="1"]').forEach(control => { control.disabled = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', unlock, {once: true});
  else unlock();
  document.addEventListener('spiedy:variant-selection', unlock);
  document.addEventListener('shopify:section:load', unlock);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["studio-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const configuration = document.getElementById('StudioConfig');
    if (!configuration || window.spiedyStudioReady) return;
    let config;
    try { config = JSON.parse(configuration.textContent); }
    catch { return; }
    window.spiedyStudioReady = true;
    const drawer = document.getElementById('StudioCart');
    const zoom = document.getElementById('StudioZoom');
    const live = document.querySelector('[data-studio-announcer]');
    const products = new WeakMap();
    let pendingCart = false;
    let opener = null;
    const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.currency}).format(value / 100);
    const announce = message => { if (live) live.textContent = message; };
    const errorAt = (element, message) => { if (element) { element.textContent = message || ''; element.hidden = !message; } };
    const jsonRequest = async (url, options = {}) => {
      const response = await fetch(url, {credentials: 'same-origin', ...options, headers: {Accept: 'application/json', ...options.headers}});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : config.cartError);
      return data;
    };
    const closeCart = () => { if (drawer?.open) drawer.close(); document.documentElement.style.overflow = ''; opener?.focus({preventScroll: true}); };
    const showCart = () => {
      if (!drawer?.showModal) { location.assign(config.cart); return; }
      if (!drawer.open) { opener = document.activeElement; drawer.showModal(); }
      document.documentElement.style.overflow = 'hidden';
    };
    const renderCart = markup => {
      if (!markup) throw new Error(config.cartError);
      const fragment = new DOMParser().parseFromString(markup, 'text/html');
      const inner = fragment.querySelector('[data-studio-cart-inner]');
      if (!inner) throw new Error(config.cartError);
      document.getElementById('StudioCartContent').innerHTML = markup;
      const full = document.querySelector('[data-studio-cart-page-content]');
      if (full) full.innerHTML = inner.outerHTML;
      document.querySelectorAll('[data-studio-cart-count]').forEach(el => { el.textContent = inner.dataset.cartCount; });
    };
    const refreshCart = async data => {
      let markup = data?.sections?.['studio-cart'];
      if (!markup) {
        const address = new URL(location.href);
        address.searchParams.set('sections', 'studio-cart');
        const sections = await jsonRequest(address.toString());
        markup = sections['studio-cart'];
      }
      renderCart(markup);
    };
    const addItems = async (body, button, error) => {
      if (pendingCart) return;
      pendingCart = true;
      const priorDisabled = button?.disabled;
      const label = button?.querySelector('[data-studio-add-label]');
      const priorLabel = label?.textContent;
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      if (label) label.textContent = config.addingLabel;
      errorAt(error, '');
      let added = false;
      try {
        let options;
        if (body instanceof FormData) {
          body.set('sections', 'studio-cart');
          body.set('sections_url', location.pathname);
          options = {method: 'POST', body};
        } else {
          options = {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({...body, sections: ['studio-cart'], sections_url: location.pathname})};
        }
        const result = await jsonRequest(config.add, options);
        added = true;
        announce(config.addedLabel);
        await refreshCart(result);
        showCart();
      } catch (errorObject) {
        if (added) { location.assign(config.cart); return; }
        errorAt(error, errorObject.message || config.addError);
        announce(errorObject.message || config.addError);
      } finally {
        pendingCart = false;
        if (button) { button.disabled = priorDisabled; button.removeAttribute('aria-busy'); }
        if (label) label.textContent = priorLabel;
      }
    };
    const changeItem = async (key, quantity, source) => {
      if (pendingCart) return;
      pendingCart = true;
      const scope = source.closest('[data-studio-cart-inner]');
      scope?.setAttribute('aria-busy', 'true');
      const checkout = scope?.querySelector('[name="checkout"]');
      if (checkout) checkout.disabled = true;
      errorAt(scope?.querySelector('[data-studio-cart-error]'), '');
      try {
        const result = await jsonRequest(config.change, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: key, quantity, sections: ['studio-cart'], sections_url: location.pathname})});
        await refreshCart(result);
        const activeScope = drawer?.open ? drawer : document.querySelector('[data-studio-cart-page-content]');
        const replacement = Array.from(activeScope?.querySelectorAll('[data-studio-cart-qty]') || []).find(el => el.dataset.key === key);
        if (replacement) replacement.focus({preventScroll: true});
        else activeScope?.querySelector('[name="checkout"],a,button')?.focus({preventScroll: true});
      } catch (error) { errorAt(scope?.querySelector('[data-studio-cart-error]'), error.message || config.cartError); }
      finally { pendingCart = false; scope?.removeAttribute('aria-busy'); if (checkout) checkout.disabled = false; }
    };
    const selectVariant = (root, id, changeUrl = true) => {
      if (!root) return false;
      const variants = products.get(root);
      const variant = variants?.find(v => String(v.id) === String(id));
      if (!variant) return false;
      const select = root.querySelector('[data-studio-native-variant]');
      if (select) select.value = variant.id;
      root.querySelectorAll('[data-studio-variant]').forEach(button => {
        const selected = String(button.dataset.studioVariant) === String(id);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      root.querySelectorAll('[data-studio-model-name]').forEach(el => { el.textContent = variant.name; });
      root.querySelectorAll('[data-studio-finish]').forEach(el => { el.textContent = variant.finish; });
      root.querySelectorAll('[data-studio-price]').forEach(el => { el.textContent = variant.priceText; });
      root.querySelectorAll('[data-studio-compare]').forEach(el => { el.textContent = variant.compareText; el.hidden = !(variant.compare > variant.price); });
      root.querySelectorAll('[data-studio-sale]').forEach(el => { el.hidden = !(variant.compare > variant.price); });
      root.querySelectorAll('[data-studio-main-image], [data-studio-sticky-image]').forEach(img => { if (variant.image) { const imageUrl = new URL(variant.image, location.origin); const small = img.hasAttribute('data-studio-sticky-image'); imageUrl.searchParams.set('width', small ? '100' : '800'); img.src = imageUrl.toString(); if (small) img.removeAttribute('srcset'); else img.srcset = [400,600,800,1200].map(width => { const sized = new URL(variant.image, location.origin); sized.searchParams.set('width', String(width)); return sized.toString() + ' ' + width + 'w'; }).join(', '); img.alt = variant.alt; } });
      root.querySelectorAll('[data-studio-add], [data-studio-sticky-add]').forEach(button => { button.disabled = !variant.available; });
      root.querySelectorAll('[data-studio-add-label]').forEach(el => { el.textContent = variant.available ? config.addLabel : config.soldLabel; });
      const sticky = root.querySelector('[data-studio-sticky-add]');
      if (sticky) sticky.textContent = variant.available ? config.addLabel : config.soldLabel;
      errorAt(root.querySelector('[data-studio-product-error]'), '');
      if (changeUrl && document.body.dataset.pageType === 'product') { const address = new URL(location.href); address.searchParams.set('variant', id); history.replaceState({}, '', address); }
      announce(variant.name + ' — ' + variant.priceText);
      document.dispatchEvent(new CustomEvent('spiedy:variant-selection', {detail: {variantId: variant.id}}));
      return true;
    };
    const updateBuilder = root => {
      let count = 0, total = 0;
      const preview = root.querySelector('[data-studio-build-preview]');
      preview.replaceChildren();
      root.querySelectorAll('[data-studio-build-qty]').forEach(input => {
        const qty = Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
        input.value = qty;
        count += qty;
        total += qty * Number(input.dataset.price);
        const card = input.closest('[data-studio-build-card]');
        card.classList.toggle('is-selected', qty > 0);
        if (qty > 0) { const img = card.querySelector('img')?.cloneNode(); if (img) { img.removeAttribute('srcset'); img.width = 40; img.height = 40; preview.append(img); } }
      });
      root.querySelector('[data-studio-build-count]').textContent = count;
      root.querySelector('[data-studio-build-total]').textContent = format(total);
      root.querySelector('[data-studio-build-add]').disabled = count === 0;
    };
    const initialize = () => {
      document.querySelectorAll('[data-studio-product]').forEach(root => {
        if (products.has(root)) return;
        try {
          const variantData = root.querySelector('[data-studio-variants]');
          const select = root.querySelector('[data-studio-native-variant]');
          const picker = root.querySelector('[data-studio-picker]');
          if (!variantData || !select || !picker) return;
          const variants = JSON.parse(variantData.textContent);
          if (!Array.isArray(variants) || !variants.length) return;
          products.set(root, variants);
          select.hidden = true;
          const label = root.querySelector('label[for="' + select.id + '"]');
          if (label) label.removeAttribute('for');
          picker.hidden = false;
          selectVariant(root, select.value, false);
        } catch {
          products.delete(root);
        }
      });
      document.querySelectorAll('[data-studio-build]').forEach(root => {
        try {
          const form = root.querySelector('[data-studio-build-form]');
          const fallback = root.querySelector('[data-studio-build-fallback]');
          if (!form) return;
          form.hidden = false;
          if (fallback) fallback.hidden = true;
          updateBuilder(root);
        } catch {
          const form = root.querySelector('[data-studio-build-form]');
          const fallback = root.querySelector('[data-studio-build-fallback]');
          if (form) form.hidden = true;
          if (fallback) fallback.hidden = false;
        }
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('click', async event => {
      const target = event.target.closest('button,a');
      if (!target) return;
      if (target.matches('[data-step]')) {
        const input = target.parentElement.querySelector('input');
        if (!input || input.disabled || (pendingCart && input.matches('[data-studio-cart-qty]'))) return;
        const min = Number(input.min || 0), max = Number(input.max || 99);
        input.value = Math.max(min, Math.min(max, (parseInt(input.value, 10) || min) + Number(target.dataset.step)));
        input.dispatchEvent(new Event('change', {bubbles: true}));
      } else if (target.matches('[data-studio-variant]')) {
        selectVariant(target.closest('[data-studio-product]'), target.dataset.studioVariant);
      } else if (target.matches('[data-studio-select]') && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
        const root = document.querySelector('[data-studio-product]');
        if (root && selectVariant(root, target.dataset.studioSelect)) { event.preventDefault(); root.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); root.querySelector('[data-studio-picker] button[aria-pressed="true"]')?.focus({preventScroll: true}); }
      } else if (target.matches('[data-studio-cart-open]')) {
        event.preventDefault(); showCart();
        try { await refreshCart(); } catch { location.assign(config.cart); }
      } else if (target.matches('[data-studio-cart-close]')) closeCart();
      else if (target.matches('[data-studio-continue]')) { closeCart(); }
      else if (target.matches('[data-studio-remove]')) { event.preventDefault(); await changeItem(target.dataset.studioRemove, 0, target); }
      else if (target.matches('[data-studio-quick-add]')) { await addItems({items: [{id: Number(target.dataset.studioQuickAdd), quantity: 1}]}, target, target.closest('[data-studio-cart-inner]')?.querySelector('[data-studio-cart-error]')); }
      else if (target.matches('[data-studio-zoom]')) { const image = target.closest('[data-studio-product]').querySelector('[data-studio-main-image]'); const large = zoom.querySelector('img'); large.src = image.currentSrc || image.src; large.alt = image.alt; if (zoom.showModal) zoom.showModal(); }
      else if (target.matches('[data-studio-zoom-close]')) zoom.close();
      if (target.closest('.st-mobile-menu nav')) target.closest('.st-mobile-menu').open = false;
    });
    document.addEventListener('change', event => {
      const input = event.target;
      if (input.matches('[data-studio-native-variant]')) selectVariant(input.closest('[data-studio-product]'), input.value);
      else if (input.matches('[data-studio-build-qty]')) updateBuilder(input.closest('[data-studio-build]'));
      else if (input.matches('[data-studio-cart-qty]')) changeItem(input.dataset.key, Math.max(0, Math.min(99, parseInt(input.value, 10) || 0)), input);
    });
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form.matches('.st-product-form') && products.has(form.closest('[data-studio-product]'))) {
        event.preventDefault();
        addItems(new FormData(form), form.querySelector('[data-studio-add]'), form.querySelector('[data-studio-product-error]'));
      } else if (form.matches('[data-studio-build-form]')) {
        event.preventDefault();
        const items = Array.from(form.querySelectorAll('[data-studio-build-qty]')).filter(input => Number(input.value) > 0).map(input => ({id: Number(input.dataset.id), quantity: Number(input.value)}));
        if (items.length) addItems({items}, form.querySelector('[data-studio-build-add]'), form.querySelector('[data-studio-build-error]'));
      }
    });
    drawer?.addEventListener('click', event => { if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right) closeCart(); } });
    drawer?.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    zoom?.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
    let tick = false;
    const updateSticky = () => {
      document.querySelectorAll('[data-studio-product]').forEach(root => {
        const sticky = root.querySelector('[data-studio-sticky]');
        const button = root.querySelector('[data-studio-add]');
        if (!sticky || !button) return;
        const box = button.getBoundingClientRect();
        const hero = document.getElementById('spiedy-hero');
        const hasPassed = hero ? hero.getBoundingClientRect().bottom < 95 : root.getBoundingClientRect().top < -80;
        sticky.hidden = !hasPassed || (box.top > 70 && box.bottom < innerHeight);
      });
      tick = false;
    };
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(updateSticky); } }, {passive: true});
    addEventListener('resize', updateSticky);
    updateSticky();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
  } catch(e) { console.error(e); }
})();

})();
